export default {
  //课中活动讨论
  signInfo: {
    detail:''
  },
  signList: '',
}



// WEBPACK FOOTER //
// ./src/store/kzActivity/sign/states.js